import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './icon-button.module.css';
import { ButtonSize, ButtonVariant } from './app-button';

//
//

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  isLoading?: boolean;
  variant?: ButtonVariant;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  size?: ButtonSize;
}

//

export const IconButton: React.FC<IconButtonProps> = ({
  icon,
  isLoading = false,
  variant = 'text',
  disabled = false,
  size = 'medium',
  onClick,
  ...props
}) => {
  const buttonClasses = [styles.iconButton, styles[variant], styles[size], disabled || isLoading ? styles.disabled : '']
    .filter(Boolean)
    .join(' ');

  //

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled || isLoading} {...props}>
      {isLoading ? <div className={styles.spinner} /> : <span className={styles.icon}>{icon}</span>}
    </button>
  );
};
